"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.persistCloseConfirmationSetting = void 0;
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var persistCloseConfirmationSetting = exports.persistCloseConfirmationSetting = function persistCloseConfirmationSetting(value) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash.noop;
  var callbackCalled = false;
  var done = function done() {
    if (!callbackCalled) {
      callbackCalled = true;
      callback();
    }
  };
  _state.AppUI.user.set('askConfirmationDeckClose', value);
  _state.AppUI.authUserStore.update({
    data: {
      askConfirmationDeckClose: value
    },
    failureCallback: done
  }, done);
};